import { ResumeLanguage } from "lib/redux/types";
import React from "react";
import { TemplateElevenResumeSection } from "./common";
import { View, Text } from "@react-pdf/renderer";
import { spacing, styles } from "../ResumePDF/styles";
import { ResumePDFDescription, ResumePDFText } from "../ResumePDF/common";

const Languages = ({
  heading,
  languages,
  themeColor,
}: {
  heading: string;
  languages: ResumeLanguage[];
  themeColor: string;
}) => {
  return (
    <TemplateElevenResumeSection themeColor={themeColor} heading={heading}>
      <View
        wrap={false}
        style={{
          ...styles.flexRow,
          flexWrap: "wrap",
        }}
      >
        {languages.map(({ language, level, descriptions }, idx) => (
          <View
            key={idx}
            style={{
              ...styles.flexCol,
              width: "40%",
              marginBottom: spacing["1"],
              marginRight: spacing["1"],
            }}
          >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <ResumePDFText bold={true}>
                {language}
                {level && ": "}
              </ResumePDFText>
              {level && <ResumePDFText>{level}</ResumePDFText>}
            </View>
            <View style={{ ...styles.flexRow, marginTop: spacing["0.5"] }}>
              <ResumePDFDescription items={descriptions} />
            </View>
          </View>
        ))}
      </View>
    </TemplateElevenResumeSection>
  );
};

export default Languages;
